// The editor creator to use.
import {
  Autoformat,
  BlockQuote,
  Bold,
  ClassicEditor as ClassicEditorBase,
  Essentials,
  Heading,
  Italic,
  Link,
  List,
  Paragraph,
  RemoveFormat,
  Strikethrough,
  Subscript,
  Superscript,
  Underline,
  Undo,
} from 'ckeditor5'

import 'ckeditor5/ckeditor5.css'

class ClassicEditor extends ClassicEditorBase {
  static builtinPlugins = [
    Essentials,
    Autoformat,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Superscript,
    Subscript,
    BlockQuote,
    Heading,
    Link,
    List,
    Paragraph,
    RemoveFormat,
    Undo,
  ]

  // Editor configuration.
  static defaultConfig = {
    licenseKey: 'GPL',
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        '|',
        'superscript',
        'subscript',
        '|',
        'removeFormat',
        '|',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'blockQuote',
        '|',
        'undo',
        'redo',
      ],
    },
    language: 'nl',
  }
}

export default ClassicEditor
